import { BreedDto } from 'src/dto/breed.dto'
import { BreedService } from 'src/services/api/breed.service'

export class BreedController {
  private service: BreedService

  constructor() {
    this.service = new BreedService()
  }

  public async getBreedList(): Promise<BreedDto[]> {
    const response = await this.service.getBreedList()
    const dataOrdered = response.data.sort((a: BreedDto, b: BreedDto) => a.descricao.localeCompare(b.descricao))
    return dataOrdered
  }
}
